import { InputText } from "primereact/inputtext";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getSelectedSearchType,
  getStoreLocalData,
  getUserData,
  setSelectedSearchType,
} from "../../utils/localStorage";
import "../../assets/storeDashboard/dashboard.css";
import { customerSearch } from "../../services/SearchAPI/SearchCustomer";
import AddNewCustomer from "../AddNewCustomer/AddNewCustomer";
import ButtonLink from "../../ButtonLink";

const SearchCustomer = () => {
  const navigate = useNavigate();
  const { storeData } = getUserData();

  const location = useLocation();
  const { source } = location.state || {}; // Fallback to prevent undefined errors

  const storeId = storeData.id;

  const { storeLocalData } = getStoreLocalData();
  const countryCode = storeLocalData?.countryCode;

  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false); // New state for loading indicator
  const [selectedItem, setSelectedItem] = useState(null); // Track selected item
  const [searchTypeToggle, setSearchTypeToggle] = useState(false);
  const [searchType, setSearchType] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [addNewCustomerModalVisible, setAddNewCustomerModalVisible] =
    useState(false);
  const [validMobileNumber, setValidMobileNumber] = useState("");
  const [selectedSearchItem, setSelectedSearchItem] = useState(null); // Track selected item
  const searchTypeData = [
    "name",
    "email",
    "mobile",
    "address",
    "customerId",
    "all",
  ];

  const [filteredData, setFilteredData] = useState([]);

  const fetchSelectedSearchType = () => {
    const selectedSearchTypeData = getSelectedSearchType();
    if (selectedSearchTypeData.searchType !== null) {
      setSearchType(selectedSearchTypeData.searchType);
    } else {
      setSearchType("");
    }
  };

  useEffect(() => {
    fetchSelectedSearchType();
  }, []);

  const handleItemPressSearchType = (item) => {
    setSelectedSearchType(item);
    setSelectedSearchItem(item);
    setSearchType(item);
    setTimeout(async () => {
      setSelectedSearchItem(null);
      setSearchTypeToggle(!searchTypeToggle);
      setSearchTerm("");
    }, 100);
  };

  const debounce = (func, delay) => {
    let timeoutId;

    const debouncedFunction = (...args) => {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };

    debouncedFunction.cancel = () => {
      clearTimeout(timeoutId);
    };

    return debouncedFunction;
  };

  const handleSearch = useMemo(
    () =>
      debounce(async (text) => {
        const searchText = text?.trim() || "";

        // Clear results if search is empty
        if (!searchText) {
          setFilteredData([]);
          return;
        }

        const newData = {
          storeId,
          searchText,
          searchBy: searchType === "all" ? "" : searchType,
          maxLimit: 50,
        };

        try {

          const response = await customerSearch(storeId, newData);

          if (response?.data?.error) {
            setFilteredData([]);
            return;
          }

          const result = Array.isArray(response?.data)
            ? response.data
            : [];

          const brandCustomerFirstNames = result.map((item) => ({
            ...item,
            id: item?.id,
            firstName: item?.brandCustomer?.firstName || "",
            lastName: item?.brandCustomer?.lastName || "",
            email: item?.brandCustomer?.email || "",
            mobile: item?.brandCustomer?.mobile || "",
            customerId: item?.customerId || "",
          }));

          // Mobile number validation
          if (searchType === "mobile") {
            let isValid = false;

            if (countryCode === "+91") {
              // India: 10 digits, starts with 5-9
              isValid = /^[5-9]\d{9}$/.test(searchText);
            } else if (countryCode === "+971") {
              // UAE: 9 digits, starts with 5
              isValid = /^5\d{8}$/.test(searchText);
            } else {
              // Fallback: 6-15 digits
              isValid = /^\d{6,15}$/.test(searchText);
            }

            if (isValid && brandCustomerFirstNames.length === 0) {
              setValidMobileNumber(searchText);
              setAddNewCustomerModalVisible(true);
            }
          }

          setFilteredData(brandCustomerFirstNames);
        } catch (error) {
          console.error("Customer search error:", error);
          setFilteredData([]);
        }
      }, 500),
    [storeId, searchType, countryCode]
  );

  // Cleanup debounce when component unmounts
  useEffect(() => {
    return () => {
      handleSearch.cancel();
    };
  }, [handleSearch])

  // const handleSearch1 = async (text) => {
  //   if (text) {
  //     const newData = {
  //       storeId: storeId,
  //       searchText: text,
  //       searchBy: searchType === "all" ? "" : searchType,
  //       maxLimit: 50,
  //     };
  //     try {
  //       console.log("newData", newData)
  //       const response = await customerSearch(storeId, newData);
  //       if (!response.data.error) {
  //         const Res = response.data;
  //         const brandCustomerFirstNames = Res.map((item) => ({
  //           id: item.id,
  //           firstName: item.brandCustomer.firstName,
  //           lastName: item.brandCustomer.lastName
  //             ? item.brandCustomer.lastName
  //             : "",
  //           email: item.brandCustomer.email,
  //           mobile: item.brandCustomer.mobile,
  //           customerId: item.brandCustomer.customerId,
  //           ...item,
  //         }));

  //         // if (searchType === "mobile") {
  //         //   if (/^\d{10}$/.test(text) && brandCustomerFirstNames.length === 0) {
  //         //     // Set the valid mobile number and show the modal
  //         //     setValidMobileNumber(text);
  //         //     setAddNewCustomerModalVisible(true);
  //         //   }
  //         // }

  //         if (searchType === "mobile") {
  //           let isValid = false;

  //           if (countryCode === "+91") {
  //             // India: starts with 5-9 and 10 digits
  //             isValid = /^[5-9]\d{9}$/.test(text);
  //           } else if (countryCode === "+971") {
  //             // UAE: starts with 5 and 9 digits
  //             isValid = /^5\d{8}$/.test(text);
  //           } else {
  //             // Fallback validation (digits only, length 6-15)
  //             isValid = /^\d{6,15}$/.test(text);
  //           }

  //           if (isValid && brandCustomerFirstNames.length === 0) {
  //             setValidMobileNumber(text);
  //             setAddNewCustomerModalVisible(true);
  //           }
  //         }
  //         setFilteredData(brandCustomerFirstNames);
  //         // setSearchTerm(text);
  //       }
  //     } catch (error) {
  //       console.error("Error:", error);
  //     }
  //   }
  // };

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const handleSearchType = () => {
    setSearchTypeToggle(!searchTypeToggle);
  };

  const handleNumberChange = (inputValue) => {
    // const copyNumber = inputValue.replace(/^\+91\s*|\s+/g, "");
    //  const rawInput = inputValue.replace(/^\+91\s*|\s+/g, "");

    const escapeRegex = (str) =>
      str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const escapedCountryCode = escapeRegex(countryCode);

    const rawInput = inputValue.startsWith(countryCode)
      ? inputValue.replace(
        new RegExp(`^${escapedCountryCode}\\s*|\\s+`, "g"),
        ""
      )
      : inputValue.replace(/\s+/g, "");

    // Keep only English letters (A-Z, a-z) and numbers (0-9)
    const copyNumber = rawInput.replace(/[^A-Za-z0-9\.,]/g, "");

    setSearchTerm(copyNumber);
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearchTimeout(
      setTimeout(() => {
        handleSearch(copyNumber);
      }, 50) // Adjust the delay (in milliseconds) as needed
    );
  };

  // const handleAllData = (inputValue) => {
  //   // const copyNumber = inputValue.replace(/^\+91\s*|\s+/g, '');
  //   const copyNumber = inputValue.startsWith("+91")
  //     ? inputValue.replace(/^\+91\s*|\s+/g, "")
  //     : inputValue;
  //   setSearchTerm(copyNumber);
  //   if (searchTimeout) {
  //     clearTimeout(searchTimeout);
  //   }
  //   setSearchTimeout(
  //     setTimeout(() => {
  //       handleSearch(copyNumber);
  //     }, 50) // Adjust the delay (in milliseconds) as needed
  //   );
  // };

  const handleAllData = (inputValue) => {
    // Remove +91 prefix and all spaces
    //  const rawInput = inputValue.startsWith("+91")
    //    ? inputValue.replace(/^\+91\s*|\s+/g, "")
    //    : inputValue;

    const escapeRegex = (str) =>
      str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const escapedCountryCode = escapeRegex(countryCode);

    const rawInput = inputValue.startsWith(countryCode)
      ? inputValue.replace(
        new RegExp(`^${escapedCountryCode}\\s*|\\s+`, "g"),
        ""
      )
      : inputValue.replace(/\s+/g, " ");

    // Keep only English letters (A-Z, a-z) and numbers (0-9)
    const copyNumber = rawInput.replace(/[^A-Za-z0-9@\-., ]/g, "");

    setSearchTerm(copyNumber);

    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearchTimeout(
      setTimeout(() => {
        handleSearch(copyNumber);
      }, 50)
    );
  };

  const handleStringChange = (inputValue) => {
    const rawInput = inputValue;
    const copyNumber = rawInput.replace(/[^A-Za-z0-9@\-., ]/g, "");
    setSearchTerm(copyNumber);
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearchTimeout(
      setTimeout(() => {
        handleSearch(copyNumber);
      }, 50) // Adjust the delay (in milliseconds) as needed
    );
  };

  const handleChange = (text) => {
    const inputValue = text;

    if (searchType === "mobile") {
      handleNumberChange(inputValue);
    }
    if (
      searchType === "name" ||
      searchType === "email" ||
      searchType === "address" ||
      searchType === "customerId"
    ) {
      handleStringChange(inputValue);
    } else {
      handleAllData(inputValue);
    }
  };

  const handleItemPress = (item) => {
    setSelectedItem(item.id);
    setIsLoading(true);
    setTimeout(async () => {
      setIsLoading(false);
      setSelectedItem(null);
      if (source === "nav") {
        navigate("/BookNewOrder", {
          state: {
            storeCustomerId: item.id,
          },
        });
      } else {
        navigate("/CustomerInfo", {
          state: {
            storeCustomerId: item.id,
          },
        });
      }
      setSearchTerm("");
    }, 1000); // Replace with actual async operation duration
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "30px", cursor: "pointer", color: "#FFF" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <InputText
                value={searchTerm}
                placeholder={
                  searchType === "name"
                    ? "Search Users By Full Name"
                    : searchType === "mobile"
                      ? "Search Users By Mobile No."
                      : searchType === "email"
                        ? "Search Users By Email"
                        : searchType === "address"
                          ? "Search Users By Address"
                          : searchType === "customerId"
                            ? "Search Users By Customer Id"
                            : "Search Users By Name, Mobile, Etc."
                }
                style={{
                  width: "90%",
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                  border: "none",
                  color: "#fff",
                  fontSize: 20,
                  fontWeight: "500",
                }}
                keyboardType={searchType === "mobile" ? "phone-pad" : "default"}
                maxLength={searchType === "mobile" ? 15 : 100}
                disabled={!searchTypeToggle ? false : true}
                className="customer-placeholder"
                autoFocus={true}
                onChange={(e) => {
                  handleChange(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="flex justify-content-center align-items-center mr-5">
            {searchTerm ? (
              <div
                onClick={() => handleClearSearch()}
                style={{ cursor: "pointer" }}
              >
                <i
                  className="pi pi-times"
                  style={{ fontSize: "27px", color: "#fff" }}
                ></i>
              </div>
            ) : (
              <div
                onClick={() => handleSearchType()}
                style={{ cursor: "pointer" }}
              >
                <i
                  className={
                    !searchTypeToggle ? "pi pi-angle-down" : "pi pi-angle-up"
                  }
                  style={{ fontSize: "30px", color: "#fff" }}
                ></i>
              </div>
            )}
          </div>
        </div>
      </div>
      <div>
        {searchTypeToggle ? (
          <div>
            <div
              className="surface-0  pl-4 py-2 border-bottom-1"
              style={{
                "--border-radius": "50px",
                "--surface-0": "#F1F7FF",
                borderBottomColor: "#D2DBD6",
              }}
            >
              <p className="text-xl font-medium">
                Please Select Type of Search
              </p>
            </div>
            <div>
              {searchTypeData?.map((item) => (
                <div
                  key={item.mobile}
                  className="px-5 py-2 border-round-md border-bottom-1 flex justify-content-between"
                  style={{ borderBottomColor: "#D2DBD6", cursor: "pointer" }}
                  onClick={() => handleItemPressSearchType(item)}
                >
                  <p
                    className="text-color text-lg font-normal uppercase"
                    style={{
                      "--text-color": "#75879B",
                    }}
                  >
                    By {item}
                  </p>
                  {selectedSearchItem === item && (
                    <div className="flex align-self-center">
                      <i
                        className="pi pi-check"
                        style={{ fontSize: "20px", color: "#008EFF" }}
                      ></i>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div>
            {searchTerm ? (
              filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <div
                    key={item.id}
                    className="px-5 py-2 border-bottom-1 flex justify-content-between"
                    style={{ borderBottomColor: "#D2DBD6", cursor: "pointer" }}
                    onClick={() => handleItemPress(item)}
                  >
                    <p
                      className="text-lg uppercase"
                      style={{ color: "#75879B" }}
                    >
                      {item.firstName} {item.lastName}, {item.mobile},{" "}
                      {item.address.addressLine1}
                    </p>
                    <p
                      className="text-lg uppercase"
                      style={{ color: "#75879B" }}
                    >
                      {item.customerId !== "" ? item.customerId : ""}
                    </p>
                    {selectedItem === item.id && (
                      <i
                        className="pi pi-check"
                        style={{ fontSize: "20px", color: "#008EFF" }}
                      ></i>
                    )}
                  </div>
                ))
              ) : (
                <div className="flex justify-content-center align-items-center flex-column">
                  <div className="my-5">
                    <img
                      style={{ width: "100%", height: "250px" }}
                      src="/Laundy_App_Icons_Gifs/Search_Empty.gif"
                      alt="logo"
                    />
                  </div>
                  <div className="flex justify-content-center align-items-center flex-column">
                    <h4 className=" text-3xl font-bold">
                      Your Search Result is Empty!
                    </h4>
                    <div>
                      <p className=" text-xl font-normal">
                        You haven't searched any user till now! Find
                        customers/users to check their results
                      </p>
                    </div>
                  </div>
                </div>
              )
            ) : (
              <div className="flex justify-content-center align-items-center flex-column">
                <div className="my-5">
                  <img
                    style={{ width: "100%", height: "250px" }}
                    src="/Laundy_App_Icons_Gifs/Search_Empty.gif"
                    alt="logo"
                  />
                </div>
                <div className="flex justify-content-center align-items-center flex-column">
                  <h4 className=" text-3xl font-bold">
                    Your Search Result is Empty!
                  </h4>
                  <div>
                    <p className=" text-xl font-normal">
                      You haven't searched any user till now! Find
                      customers/users to check their results
                    </p>
                  </div>
                </div>
              </div>
            )}

            {isLoading && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.2)",
                  zIndex: 1000,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="flex justify-content-center align-items-center flex-column">
                  <i
                    className="pi pi-spin pi-spinner"
                    style={{ fontSize: "120px", color: "#008EFF" }}
                  ></i>
                  <p className="text-3xl font-bold">Searching...</p>
                  <p className="text-xl font-normal">
                    Please wait for a second! We are finding your searched
                    customer details.
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <div>
        <AddNewCustomer
          setAddNewCustomerModalVisible={setAddNewCustomerModalVisible}
          addNewCustomerModalVisible={addNewCustomerModalVisible}
          storeId={storeId}
          validMobileNumber={validMobileNumber}
          manualInput={false}
        />
      </div>
      <ButtonLink />
    </div>
  );
};

export default SearchCustomer;
